// removed by extract-text-webpack-plugin
module.exports = {"component":"_2-6sUv0xL0eyIMlnBHgPMn","header":"_34VS9R57GzNblThTdop13Z","firstFullPageItem":"_3yMFaSWaEfiCOFwsYYhMgT","goeasySection":"_3R7vyn7BnwxtYfQPMYL-z_","nextIcon":"_359Pg1cLo6NJ6yFUK7-L2T","xiala":"_3CLrDYuRYJ0SqggCmMPQjU","buyBtn":"w6VTVA09qzyBVGTyUStPi","traioef_an":"_2AWcBHYs3toWWTYprqORWD"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ServiceDetail/ServiceDetail.scss
 ** module id = 181
 ** module chunks = 0
 **/